/**
 * Report a mouse pointer over `element` and where over it it is (-1..1 each way, y up).
 *
 * @param {HTMLElement} element
 * @param {(on: boolean, look?: { x: number, y: number }) => void} onLook
 */
export function bindPointerLook(element, onLook) {
	const look = event => {
		const rect = element.getBoundingClientRect()
		return {
			x: ((event.clientX - rect.left) / rect.width) * 2 - 1,
			y: 1 - ((event.clientY - rect.top) / rect.height) * 2,
		}
	}
	const mouse = event => event.pointerType === 'mouse'
	element.addEventListener('pointerenter', event => mouse(event) && onLook(true, look(event)))
	element.addEventListener('pointermove', event => mouse(event) && onLook(true, look(event)))
	element.addEventListener('pointerleave', () => onLook(false))
}
